/**
 * Standalone Policies App Component
 *
 * Loads the Policies PoliciesRouterProvider directly when running
 * in standalone mode (not as MFE). The policies app has its own
 * TanStack Router, so we render its self-contained router provider.
 *
 * ThemeProvider is required because the Policies App's components call
 * `useTheme` from `@repo/mfe-core`. In MFE mode `AppWrapper.tsx` supplies it;
 * in this direct-import standalone path we supply it here.
 */
import { ThemeProvider } from "@repo/mfe-core";
import { PoliciesRouterProvider } from "../../../../policies/src/PoliciesRouteProvider";

export function PoliciesApp() {
  return (
    <ThemeProvider>
      <PoliciesRouterProvider />
    </ThemeProvider>
  );
}
